import React, { useRef, useEffect } from 'react';
import {
  func,
  oneOfType,
  arrayOf,
  node,
  string,
  bool,
  shape
} from 'prop-types';
import { XDataGrid, withPopupContent } from '@core/components';
import { useDataSource, useCustomEdit } from '@core/hooks';
import MainPopup from './MainPopup/MainPopup';

const WiadomosciSzablony = ({
  title,
  onFocusedRowChanged,
  currentRowData,
  setCurrentRowData,
  setShowPopup,
  showPopup,
  dataSourceFn,
  children,
  rowType
}) => {
  const dataGridRef = useRef(null);
  const firstLoad = useRef(true);

  const handleEdit = useCustomEdit(currentRowData, setShowPopup);

  const addRowDataTypeToEvent = (e, WiadomoscTyp) => {
    return { ...e, row: { ...e.row, data: { ...e.row.data, WiadomoscTyp } } };
  };

  const handleFocusedRowChange = (e) => {
    if (!e.row?.data) return;
    const focusedEvent =
      rowType === 'Email' ? addRowDataTypeToEvent(e, 'Email') : e;
    onFocusedRowChanged(focusedEvent);
  };

  // api
  const { dataSource, unauthorized } = useDataSource(
    dataSourceFn,
    dataGridRef.current
  );

  useEffect(() => {
    if (!showPopup && !firstLoad.current) {
      const dgInstance = dataGridRef.current.instance;

      dgInstance.refresh().then(() => {
        dgInstance.selectRows([currentRowData.Id]);

        const data = dgInstance.getSelectedRowsData()[0] || {};

        dgInstance.deselectAll();

        setCurrentRowData({
          ...data,
          WiadomoscTyp: rowType || data.WiadomoscTyp
        });
      });
    } else {
      firstLoad.current = false;
    }
  }, [showPopup]);

  return (
    <XDataGrid
      dataSource={unauthorized ? [] : dataSource}
      errorRowEnabled={!unauthorized}
      onFocusedRowChanged={handleFocusedRowChange}
      refs={dataGridRef}
      title={title}
      toolbarOptions={{
        copy: false,
        add: false,
        remove: false,
        previewData: false,
        actionData: false,
        edit: handleEdit
      }}
    >
      {children}
    </XDataGrid>
  );
};

WiadomosciSzablony.propTypes = {
  title: string.isRequired,
  currentRowData: shape({}),
  setCurrentRowData: func.isRequired,
  showPopup: bool.isRequired,
  onFocusedRowChanged: func.isRequired,
  children: oneOfType([arrayOf(node), node]).isRequired,
  dataSourceFn: func.isRequired,
  setShowPopup: func.isRequired,
  rowType: string
};

export default withPopupContent(WiadomosciSzablony, MainPopup, true, {
  fullScreen: true
});
